import React from 'react';
import { Button, Input } from '../../../../components';
import { useOrgForm } from './useOrgForm';

import email from '../../icons/email.svg';
import orgIcon from '../../icons/org.svg';
import url from '../../icons/url.svg';
import location from '../../icons/location.svg';
import { Organization } from '../../../../types';

type AddOrganizationProps = {
  open: boolean;
  onClose: () => void;
  isAdd?: boolean;
  org?: Organization | null;
  isMyOrgEdit?: boolean;
};

export const AddOrganization: React.FC<AddOrganizationProps> = ({
  onClose,
  open,
  isAdd = false,
  org,
  isMyOrgEdit = false,
}: AddOrganizationProps): JSX.Element => {
  const {
    errors,
    handleCancel,
    handleChange,
    handleSubmit,
    touched,
    values,
  } = useOrgForm({ onClose, isAdd, org, isMyOrgEdit });

  return (
    <>
      <div className={`add-user add-user-${open ? 'open' : 'closed'}`}>
        <h3 className="add-user__title">
          {isAdd ? 'Add New' : 'Edit'} Organization
        </h3>
        <form onSubmit={handleSubmit}>
          <Input
            error={touched.orgName ? errors.orgName : ''}
            onChange={handleChange}
            value={values.orgName}
            name="orgName"
            icon={orgIcon}
            className="add-user__input"
            label="Organization name"
            disabled={!isAdd}
          />
          <Input
            error={touched.url ? errors.url : ''}
            onChange={handleChange}
            value={values.url}
            name="url"
            icon={url}
            className="add-user__input"
            label="URL"
          />
          <Input
            error={touched.email ? errors.email : ''}
            onChange={handleChange}
            value={values.email}
            name="email"
            icon={email}
            className="add-user__input"
            label="Primary email"
            disabled={!isAdd}
          />
          {isMyOrgEdit ? (
            <Input
              error={touched.location ? errors.location : ''}
              onChange={handleChange}
              value={values.location as string}
              name="location"
              label="Location"
              icon={location}
              className="add-user__input"
            />
          ) : null}
          <Button type="submit" className="add-user__btn" variant="common">
            {isAdd ? 'Add' : 'Save'}
          </Button>
          <Button
            className="add-user__btn"
            onClick={handleCancel}
            variant="text"
          >
            Cancel
          </Button>
        </form>
      </div>
    </>
  );
};
